module.exports = __webpack_public_path__ + "img/max_logo_white.28075f7c.png";